import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";

// Define a type for the slice state
interface PermissionState {
  id: number;
  data: any;
}

// Define the initial state using that type
const initialState: PermissionState = {
  id: 0,
  data: {},
};

export const spaceSlice = createSlice({
  name: "permission",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setId: (state, action: PayloadAction<number>) => {
      state.id = action.payload;
    },
    setPermissions: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
    },
  },
});

export const { setId, setPermissions } = spaceSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getId = (state: RootState) => state.permission.id;
export const getPermissions = (state: RootState) => state.permission.data;

export default spaceSlice.reducer;
